module.exports = __webpack_public_path__ + "img/loxone.97d7f0f2.png";